module.exports = __webpack_public_path__ + "img/filters-ductwork-cleaned-02-square.7d66ee80.jpg";